document.addEventListener('change', (e) => {
  // Small helper: when a variant select changes, update the hidden variant id input
  const form = e.target.closest('form[data-pp-product-form]');
  if (!form) return;
  if (!e.target.matches('[data-pp-variant-select]')) return;

  const selects = [...form.querySelectorAll('[data-pp-variant-select]')];
  const chosen = selects.map(s => s.value).join(' / ');
  const variants = JSON.parse(form.querySelector('[data-pp-variants-json]').textContent || '[]');
  const match = variants.find(v => v.options.join(' / ') === chosen);
  const idInput = form.querySelector('input[name="id"]');
  if (match && idInput) idInput.value = match.id;
});